<div class="app-header px-2 py-1.5 sm:p-4 sm:px-14 lg:h-20">
    <div class="menu-section flex items-center flex-1 gap-x-2">
        @if (hasAdditionalItems()) {
            <button type="button"
                    class="inline-flex mr-2 mb-2 p-2 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
                    (click)="onToggleSidenav()">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 block" viewBox="0 0 24 24" fill="currentColor">
                    <rect x="3" y="6" width="18" height="2" rx="1"></rect>
                    <rect x="3" y="11" width="18" height="2" rx="1"></rect>
                    <rect x="3" y="16" width="18" height="2" rx="1"></rect>
                </svg>
            </button>
        }

        <div class="image-section flex-shrink-0 cursor-pointer" routerLink="/home">
            <img priority [ngSrc]="falabellaLogo" alt="falabellaLogo" [width]="160" [height]="28" />
        </div>
    </div>

    <div class="w-44 sm:w-44 lg:w-fit user-section flex">
        <div>
            <button class="custom-button mr-4 mt-1" [matMenuTriggerFor]="menu">
                <img [ngSrc]="personOutline" alt="personOutline" [height]="19" [width]="17" />
            </button>
            <mat-menu #menu="matMenu" xPosition="after" yPosition="below" [class]="'header-menu-logout'">
                <div class="flex items-center px-4 cursor-pointer" (click)="logout()">
                    <img [ngSrc]="logoutIcon" alt="logout" [height]="24" [width]="24" class="mr-2.5" />
                    <button mat-menu-item class="custom-button" [disableRipple]="true">
                        <label class="jakarta-text text-xs lg:text-base cursor-pointer">
                            {{ 'SESSION.CLOSE' | translate }}
                        </label>
                    </button>
                </div>
            </mat-menu>
        </div>
        <div class="cursor-pointer" [matMenuTriggerFor]="menu">
            <label
                class="capitalize cursor-pointer whitespace-normal jakarta-text break-words max-w-xs text-xs sm:text-xs lg:text-base">
                {{ user().names }} {{ user().lastname }} ({{user().rol.name}})
            </label>
        </div>
    </div>
</div>
